import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Loaders from "@/shared/components/loader";
import { catchServerError } from "@/shared/helpers/catch-server-error";
import { sleep } from "@/shared/helpers/sleep.helper";
import UseSnackbar from "@/shared/hooks/use-snackbar.hook";
import useCookieSessionManager from "@rf-hooks/useCookieSessionManager";
import { useLoginGoogleCallbackMutation } from "@/shared/services/qrtk/auth/user-auth.qrtk";

function GoogleCallback() {
  const location = useLocation();
  const showMessage = UseSnackbar();
  const [LoginGoogleM] = useLoginGoogleCallbackMutation();
  const { setSessionTokenUser } = useCookieSessionManager();

  const singWithGoogle = () => {
    LoginGoogleM(location.search)
      .unwrap()
      .then((res: any) => {
        const { token, maxCoreTokenV1 } = res;
        setSessionTokenUser({ token, maxCoreTokenV1 });
        sleep(1).then(() => window.location.href === "/");
      })
      .catch(err => {
        showMessage(catchServerError(err));
        sleep(1).then(() => window.location.href === "/");
      });
  };

  useEffect(() => {
    singWithGoogle();
  }, []);

  return <Loaders />;
}

export default GoogleCallback;
